import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { OhVueIcon, addIcons } from 'oh-vue-icons';
import '@/styles/style.css'


import {GiHamburgerMenu,FaRobot,MdScienceOutlined,IoAddCircle,SiCraftcms,SiBlockchaindotcom,HiSolidDatabase,GiStack,BiDiagram3Fill,MdSecuritySharp,FaMobileAlt,GiConsoleController,BiDisplay,RiSteamFill,FaCheckCircle,HiSolidUserCircle,RiDoubleQuotesR,RiDoubleQuotesL,BiCheckCircle,FaHandshake,BiPeopleFill,IoSchoolSharp, HiShoppingCart, FaFlag, RiZhihuFill, RiMoneyEuroCircleFill } from 'oh-vue-icons/icons';
addIcons(GiHamburgerMenu,FaRobot,MdScienceOutlined,IoAddCircle,SiCraftcms,SiBlockchaindotcom,HiSolidDatabase,GiStack,BiDiagram3Fill,MdSecuritySharp,FaMobileAlt,GiConsoleController,BiDisplay,RiSteamFill,FaCheckCircle,HiSolidUserCircle,RiDoubleQuotesR,RiDoubleQuotesL,BiCheckCircle,FaHandshake,BiPeopleFill,IoSchoolSharp,HiShoppingCart, FaFlag, RiZhihuFill, RiMoneyEuroCircleFill);

const app = createApp(App);


app.component("v-icon", OhVueIcon);

app.use(router).mount('#app');
